import { faCheck, faQuestion, faTruck, IconDefinition } from '@fortawesome/free-solid-svg-icons';

export enum SmartlockerDeliveryStatus {
    InTransit = 'In transit',
    Delivered = 'Delivered',
    Sorted = 'Sorted',
    Transferred = 'Transferred',
    None = 'None',
}

export const STATUS_ICONS_CLASSES: Record<string, string> = {
    [SmartlockerDeliveryStatus.InTransit]: 'bg-orange',
    [SmartlockerDeliveryStatus.Delivered]: 'bg-orange',
    [SmartlockerDeliveryStatus.Sorted]: 'bg-lightgreen',
    [SmartlockerDeliveryStatus.Transferred]: 'bg-lightgreen',
};

export const STATUS_ICONS: Record<string, IconDefinition> = {
    [SmartlockerDeliveryStatus.Delivered]: faQuestion,
    [SmartlockerDeliveryStatus.InTransit]: faQuestion,
    [SmartlockerDeliveryStatus.Sorted]: faCheck,
    [SmartlockerDeliveryStatus.Transferred]: faTruck,
};

export enum SmartlockerEndpoints {
    SearchSmartLockerDeliveries = '/SearchSmartLockerDeliveries',
    GetSmartLockers = '/GetSmartLockers',
    GenerateSmartLockerAccessCode = '/GenerateSmartLockerAccessCode',
    GetSmartLockerDoors = '/GetSmartLockerDoors',
    SmartLockerSorting = '/SmartLockerSorting',
    SmartLockerMaterialSorting = '/SmartLockerMaterialSorting',
    GetSmartlockerMaterials = '/GetSmartlockerMaterials',
    SetMaterialStatus = '/SetMaterialStatus',
}
